import type { ReactNode } from 'react';
import { Text, makeStyles, shorthands, tokens } from '@fluentui/react-components';

const useStyles = makeStyles({
  head: { display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', flexWrap: 'wrap', ...shorthands.gap('16px'), marginBottom: '20px' },
  titles: { display: 'grid', ...shorthands.gap('4px'), minWidth: 0 },
  sub: { color: tokens.colorNeutralForeground3 },
});

export function PageHeader({ title, subtitle, actions }: { title: string; subtitle?: string; actions?: ReactNode }) {
  const s = useStyles();
  return (
    <div className={s.head}>
      <div className={s.titles}>
        <Text as="h1" size={700} weight="semibold" style={{ margin: 0 }}>{title}</Text>
        {subtitle && <Text className={s.sub}>{subtitle}</Text>}
      </div>
      {actions}
    </div>
  );
}
